export const TermsConditionsPolicySelectors = {
  block: "TermsConditionsPolicy",
  checkbox: "TermsConditionsPolicy__checkbox",
  label: "TermsConditionsPolicy__label",
};
